import React from 'react';
import styles from './Breadcrumbs.scss';
import {Link} from 'react-router';
import map from 'lodash/map';

export default function Breadcrumbs({routes, params}) {
  const modifyPath = (path) => {
    if (!path.includes('garage')) {
      switch (true) {
        case (path.includes(':modelId')):
          return path.replace(':brand/:modelId', `${params.brand.brandId}/${params.model.modelId}`);
        case (path.includes(':brand')):
          return path.replace(':brand', params.brand.brandId);
        case (path.includes(':modification')):
          return path.replace(':modification', params.modification.modificationId);
        default:
          return path;
      }
    } else {
      return path;
    }
  };

  const modifyTitle = (title) => {
    switch (title) {
      case 'Модели':
        return params.brand.brandName;
      case 'Модификации':
        return params.model.modelName;
      case 'Список запчастей для ТО':
        return params.modification.modificationName;
      default:
        return title;
    }
  };

  const renderedCrumbs = map(routes, (route, i) => {
    if(!route.path) return;
    return (
      <Link
        activeClassName={styles.crumbActive}
        onlyActiveOnIndex
        to={modifyPath(route.path)}
        key={`breadcrumb_${i}`}
        className={styles.crumb}>
        {modifyTitle(route.component.routeTitle) || ''}
      </Link>
    );
  });
  return (
    <div className={styles.crumbsContainer}>
      {renderedCrumbs}
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Breadcrumbs/Breadcrumbs.jsx
 **/